import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [pwForm, setPwForm] = useState({ old_password: "", new_password: "" });

  const submit = async () => {
    try {
      await api.post("/auth/change-password", pwForm);
      toast.success("Password changed");
      onOpenChange(false);
      setPwForm({ old_password: "", new_password: "" });
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Failed to change password");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl uppercase">Change Password</DialogTitle><DialogDescription className="sr-only">Change your account password</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Current password</Label>
            <Input type="password" data-testid="old-password-input" value={pwForm.old_password} onChange={(e) => setPwForm({ ...pwForm, old_password: e.target.value })} />
          </div>
          <div>
            <Label>New password (min 6 chars)</Label>
            <Input type="password" data-testid="new-password-input" value={pwForm.new_password} onChange={(e) => setPwForm({ ...pwForm, new_password: e.target.value })} />
          </div>
          <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground" onClick={submit} data-testid="change-password-submit">Update Password</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
